import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { servicesData } from "../../data/servicesData";

const footerLinks = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/services", label: "Services" },
  { path: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="bg-aura-text text-gold-light border-t border-gold-dark/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 md:gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5 }}
            className="sm:col-span-2 md:col-span-1"
          >
            <h3 className="font-serif text-2xl md:text-3xl font-semibold text-gold-primary mb-4">
              Aura International
            </h3>
            <p className="text-gold-light/90 text-sm md:text-base max-w-md leading-relaxed">
              Marketing & Business LLC — Delivering premium marketing solutions, event management,
              and business growth strategies for brands that demand excellence.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h4 className="font-sans text-sm font-semibold text-gold-primary uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gold-light/90 hover:text-gold-primary transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: 0.15 }}
          >
            <h4 className="font-sans text-sm font-semibold text-gold-primary uppercase tracking-wider mb-4">
              Services
            </h4>
            <ul className="space-y-2">
              {servicesData.map((service) => (
                <li key={service.id}>
                  <Link
                    to={`/services/${service.id}`}
                    className="text-gold-light/90 hover:text-gold-primary transition-colors duration-300 text-sm block"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h4 className="font-sans text-sm font-semibold text-gold-primary uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-2 text-sm text-gold-light/90">
              <p>Muscat, Oman</p>
              <p>Tel: 77240531 / 76363027</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:Info@aurainternationalom.com"
                  className="hover:text-gold-primary transition-colors"
                >
                  Info@aurainternationalom.com
                </a>
              </p>
            </div>
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-12 pt-8 border-t border-gold-dark/30 flex flex-col sm:flex-row justify-between items-center gap-4"
        >
          <p className="text-gold-light text-sm">
            © {new Date().getFullYear()} Aura International Marketing & Business LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="text-gold-light text-sm">
              Powered by{" "}
              <a
                href="https://ainsoftsolutions.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold-primary hover:text-gold-light transition-colors"
              >
                ainsoftsolutions.com
              </a>
            </span>
          </div>
        </motion.div>
      </div>
    </footer>
  );
}
